import React from "react";
import { useLiveVehicles } from "@/hooks/useLiveVehicles";
import { Truck } from "lucide-react";

// Small overlay button dropped into any map wrapper. Controls the SHARED live
// fleet layer globally (on by default). Hidden when Quartix isn't available.
export default function LiveVehiclesToggle({ className = "" }) {
  const { enabled, available, setEnabled, vehicles } = useLiveVehicles();
  if (!available) return null;
  return (
    <button
      type="button"
      onClick={() => setEnabled(!enabled)}
      data-testid="live-vehicles-toggle"
      className={`absolute top-3 left-3 z-10 inline-flex items-center gap-1.5 rounded-lg border shadow px-3 py-1.5 text-xs font-semibold transition-colors ${
        enabled ? "bg-emerald-600 border-emerald-600 text-white" : "bg-white/95 border-slate-200 text-slate-600 hover:text-emerald-600"
      } ${className}`}
    >
      <Truck className="w-3.5 h-3.5" />
      {enabled ? `Live vans: ${vehicles.length}` : "Live vans: off"}
    </button>
  );
}
